"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRegExp = void 0;
exports.DateRegExp = {
    DateOnly: /^(19|20)\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/,
    TimeOnly: /^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/,
};
//# sourceMappingURL=date-regex.js.map